import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useMerchants(filters = {}) {
  const [merchants, setMerchants] = useState([]);
  const [meta, setMeta]           = useState({ total: 0, last_page: 1 });
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);

  const fetchMerchants = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const { data } = await api.get('/merchants', { params: { ...filters, ...params } });
      setMerchants(data.data);
      setMeta(data.meta);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load merchants');
    } finally { setLoading(false); }
  }, [JSON.stringify(filters)]); // eslint-disable-line

  useEffect(() => { fetchMerchants(); }, [fetchMerchants]);

  return { merchants, meta, loading, error, refetch: fetchMerchants };
}
